export const getPromoGroup = ({ groupId }) => ({
  url: `/me/promotion_groups/${groupId}`,
})
